const VARIABLE_BLOT_NAME = 'variable';

function forEachVariableBlotInRange(quill, range, callback) {
    if(!quill?.scroll || !range) {
        return;
    }
    if(range.length === 0) {
        const [blot] = quill.getLeaf(range.index);
        if(blot?.statics?.blotName === VARIABLE_BLOT_NAME) {
            callback(blot);
        }
        return;
    }
    let index = range.index;
    const end = range.index + range.length;
    while(index < end) {
        const [blot] = quill.getLeaf(index);
        if(!blot) {
            break;
        }
        if(blot.statics?.blotName === VARIABLE_BLOT_NAME) {
            callback(blot);
        }
        index += Math.max(blot.length(), 1);
    }
}

function applyVariableFormatInRange(quill, range, formatName, value) {
    forEachVariableBlotInRange(quill, range, blot => {
        if(typeof blot.format === 'function') {
            blot.format(formatName, value);
        }
    });
}

function getVariableFormatInRange(quill, range, formatName) {
    let sawVariable = false;
    let allHaveFormat = true;
    forEachVariableBlotInRange(quill, range, blot => {
        sawVariable = true;
        if(blot.domNode.getAttribute(`data-${formatName}`) !== 'true') {
            allHaveFormat = false;
        }
    });
    return sawVariable ? allHaveFormat : null;
}

/**
 * Bold/italic for free-message Quill — formatText skips variable embeds.
 * @returns {boolean} false when there is no selection range
 */
export function applyQuillFormatCommand(quill, command) {
    const range = quill.getSelection(true);
    if(!range) {
        return false;
    }
    const currentFormat = quill.getFormat(range);
    const variableFormat = getVariableFormatInRange(quill, range, command);
    const next = variableFormat !== null ? !variableFormat : !currentFormat[command];

    if(range.length === 0) {
        quill.format(command, next, 'user');
    } else {
        quill.formatText(range.index, range.length, command, next, 'user');
    }
    applyVariableFormatInRange(quill, range, command, next);
    return true;
}
